module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs conversions-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product/offer',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_offers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product/country',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_country')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product/tag',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_category_product')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product/balance',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_balance_currency')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product/orders_receipt',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.orders_receipt')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-478ab49e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/product/ProductTabs.vue
// module id = 550
// module chunks = 0